export default [
  {
    path: "/settings/vehicles",
    name: "Vehicles",
    component: () => import("@/views/3pl/Settings/Vehicles/index"),
  },
  {
    path: "/settings/vehicles/new/:id",
    name: "NewVehicle",
    component: () => import("@/views/3pl/Settings/Vehicles/NewVehicle"),
  },
  {
    path: "/settings/vehicles/view",
    name: "SingleVehicle",
    component: () => import("@/views/3pl/Settings/Vehicles/SingleVehicle"),
  },
  {
    path: "/settings/vehicles/edit",
    name: "EditVehicle",
    component: () => import("@/views/3pl/Settings/Vehicles/EditVehicle"),
  },
  {
    path: "/settings/vehicles/edit-vehicle/:id",
    name: "EditVehicleFleet",
    component: () => import("@/views/3pl/Settings/Vehicles/EditVehicleFleet"),
  },
  {
    path: "/settings/vehicles/view-vehicle/:id",
    name: "ViewVehicleFleet",
    component: () => import("@/views/3pl/Settings/Vehicles/ViewVehicle"),
  },
];
